import type { IxcTradereportingV1CaisReportKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const CAIS_REPORT_BASE_PATH = getResolvedPath('/clearing/compliance/reporting/cais');

export const getCaisReportPath: EntityPathBuilder<IxcTradereportingV1CaisReportKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return CAIS_REPORT_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.reportId) {
        return undefined;
      }

      return getResolvedPath(`${CAIS_REPORT_BASE_PATH}/$reportId`, context.keys);
    }
  }
};

export function getCaisReportDetailPath(reportId: string | undefined) {
  if (!reportId) {
    return undefined;
  }

  return getCaisReportPath({ kind: 'detail', keys: { reportId } });
}
